module.exports = __webpack_public_path__ + "img/makerClentVideo.5dbe2527.jpg";